
define(
	'Calculator.CoatingVolumeCalc.CoatingVolumeCalc'
,   [
	]
,   function (
		
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{

				var pageTypeComponent = container.getComponent("PageType");

				var pageTemplateLayout1 = {
					pageTypes: ['cms-landing-page'],
					template: {
						name: 'calculator_coatingvolumecalc_coatingvolumecalc.tpl',
						displayName: 'Coating Volume Calc',
						thumbnail: ''
					}
				}

				pageTypeComponent.registerTemplate(pageTemplateLayout1);

			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			// var layout = container.getComponent('Layout');
			
			// if(layout)
			// {
			// 	layout.addChildView('Header.Logo', function() { 
			// 		return new CoatingVolumeCalcView({ container: container });
			// 	});
			// }

		}
	};
});
